var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CommercantHeader'),_c('ProduitContent',{attrs:{"product-id":_vm.productId}}),_c('ProduitDetails',{attrs:{"product-id":_vm.productId}}),_c('ProduitsApparentes',{attrs:{"product-id":_vm.productId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }